import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslatePipe } from '@ngx-translate/core';
import { SeasonPeriodsDefaultTabComponent } from './season-periods-default-tab.component';
import { SeasonPeriodsExceptionsTabComponent } from './season-periods-exceptions-tab.component';

/**
 * "Season periods" section for a water: two tabs — Periods (recurring defaults) and Exceptions
 * (year-specific overrides). Mirrors the legacy Symfony "Periode(n)" / "Uitzonderingen" tabs.
 */
@Component({
  selector: 'app-season-periods',
  templateUrl: './season-periods.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatTabsModule, TranslatePipe, SeasonPeriodsDefaultTabComponent, SeasonPeriodsExceptionsTabComponent],
})
export class SeasonPeriodsComponent {
  readonly waterId = input.required<number>();

  readonly periodsCount = signal(0);
  readonly exceptionsCount = signal(0);
}
